import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { deleteRequest } from 'helpers/api';

import confirm from 'components/confirm';

export default function ContactRolesList({ contactRoles, onDelete }) {
  const handleDelete = (role) => {
    confirm(`Are you sure you want to delete ${role.parentName}?`, {
      buttonLabel: 'Delete',
      buttonStyle: 'danger',
      title: 'Delete Contact'
    }).then(async () => {
      try {
        await deleteRequest(`/contacts/contact_roles/${role.id}`);

        onDelete(role);
      } catch (errors) {
        // TODO: We need a way to handle errors here
      }
    });
  };

  return (
    <table className="table">
      <thead>
        <tr>
          <th style={{ width: '33%' }}>Project</th>
          <th>Relation</th>
        </tr>
      </thead>
      <tbody>
        {
          contactRoles.map(role => (
            <tr key={role.id}>
              <td>
                <a href={`/projects/${role.parentId}`} name="role-project-link">
                  {role.parentName}
                </a>
              </td>
              <td name="role-relationship">{role.relationship}</td>
              {
                onDelete && (
                  <td name="role-actions">
                    <a className="btn muted-button p-0" onClick={() => handleDelete(role)}>
                      <FontAwesomeIcon className="mr-3" icon={faTrashAlt} /> Delete
                    </a>
                  </td>
                )
              }
            </tr>
          ))
        }
      </tbody>
    </table>
  );
}

ContactRolesList.propTypes = {
  contactRoles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    parentId: PropTypes.number.isRequired,
    parentName: PropTypes.string.isRequired,
    relationship: PropTypes.string.isRequired
  })).isRequired,
  onDelete: PropTypes.func
};
